import angular from 'angular'

import searchCtrl from '../search/search.controller'
import searchRoutes from './search.routes'
import searchRun from '../search/search.run'

const name = 'routingConsultSearch'

angular.module(name, [])
  .controller('searchCtrl', searchCtrl)
  .config(searchRoutes)
  .run(searchRun)

export default name



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/consult/search/search.module.js